var _circle, _rect, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 56,
    r: 55.5,
    stroke: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_83_300",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 1,
    width: 58,
    height: 111
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 1,
    width: 58,
    height: 111,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_83_300)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_83_300",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 110,
    height: 110,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 2,
    y: 1,
    width: 110,
    height: 110
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 56C5 66.2846 8.04974 76.3383 13.7636 84.8897C19.4774 93.441 27.5987 100.106 37.1005 104.042C46.6022 107.977 57.0577 109.007 67.1447 107.001C77.2317 104.994 86.4972 100.042 93.7696 92.7696C101.042 85.4972 105.994 76.2317 108.001 66.1447C110.007 56.0577 108.977 45.6022 105.042 36.1005C101.106 26.5987 94.441 18.4774 85.8897 12.7636C77.3383 7.04974 67.2846 4 57 4V4.71745C67.1427 4.71745 77.0577 7.72512 85.4911 13.3601C93.9244 18.9951 100.497 27.0044 104.379 36.375C108.26 45.7457 109.276 56.0569 107.297 66.0047C105.318 75.9526 100.434 85.0902 93.2622 92.2622C86.0902 99.4342 76.9526 104.318 67.0047 106.297C57.0569 108.276 46.7457 107.26 37.375 103.379C28.0044 99.4974 19.9951 92.9244 14.3601 84.4911C8.72512 76.0577 5.71745 66.1427 5.71745 56H5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5 56C5 66.2846 8.04974 76.3383 13.7636 84.8897C19.4774 93.441 27.5987 100.106 37.1005 104.042C46.6022 107.977 57.0577 109.007 67.1447 107.001C77.2317 104.994 86.4972 100.042 93.7696 92.7696C101.042 85.4972 105.994 76.2317 108.001 66.1447C110.007 56.0577 108.977 45.6022 105.042 36.1005C101.106 26.5987 94.441 18.4774 85.8897 12.7636C77.3383 7.04974 67.2846 4 57 4V4.71745C67.1427 4.71745 77.0577 7.72512 85.4911 13.3601C93.9244 18.9951 100.497 27.0044 104.379 36.375C108.26 45.7457 109.276 56.0569 107.297 66.0047C105.318 75.9526 100.434 85.0902 93.2622 92.2622C86.0902 99.4342 76.9526 104.318 67.0047 106.297C57.0569 108.276 46.7457 107.26 37.375 103.379C28.0044 99.4974 19.9951 92.9244 14.3601 84.4911C8.72512 76.0577 5.71745 66.1427 5.71745 56H5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 56C5 66.2846 8.04974 76.3383 13.7636 84.8897C19.4774 93.441 27.5987 100.106 37.1005 104.042C46.6022 107.977 57.0577 109.007 67.1447 107.001C77.2317 104.994 86.4972 100.042 93.7696 92.7696C101.042 85.4972 105.994 76.2317 108.001 66.1447C110.007 56.0577 108.977 45.6022 105.042 36.1005C101.106 26.5987 94.441 18.4774 85.8897 12.7636C77.3383 7.04974 67.2846 4 57 4V4.71745C67.1427 4.71745 77.0577 7.72512 85.4911 13.3601C93.9244 18.9951 100.497 27.0044 104.379 36.375C108.26 45.7457 109.276 56.0569 107.297 66.0047C105.318 75.9526 100.434 85.0902 93.2622 92.2622C86.0902 99.4342 76.9526 104.318 67.0047 106.297C57.0569 108.276 46.7457 107.26 37.375 103.379C28.0044 99.4974 19.9951 92.9244 14.3601 84.4911C8.72512 76.0577 5.71745 66.1427 5.71745 56H5Z",
    stroke: "black",
    strokeWidth: 6,
    mask: "url(#path-3-outside-1_83_300)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 57.3071C46.7455 68.0679 51.8182 72.2527 52.6364 73L78 40",
    stroke: "black",
    strokeWidth: 4,
    id: "checkmark"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1c372f902dc6647b654e815d9fde2d45.svg";
export { ForwardRef as ReactComponent };